import React from "react";
import { TimeLogDayHeader, TimeLogRow } from "./TimeLogRow";
import { groupLogsByDate, pluralLogs, summarizeLogs } from "./timeLogModel";

/**
 * Chronological list, grouped by date with a daily total. When `groupByEmployee`
 * is given ([[name, logs], …]) each employee gets a heading, then date groups.
 */
export function TimeLogList({
  logs,
  groupByEmployee = null,
  rowProps,
  onOpen,
  menuItemsFor,
  rowPropsFor,
  dayExtra,
  employeeExtra,
}) {
  const renderDays = (dayLogs) =>
    groupLogsByDate(dayLogs).map((group) => (
      <section key={group.dateIso || "unknown"} className="tl-group">
        <TimeLogDayHeader
          label={group.label}
          durationLabel={group.durationLabel}
          countLabel={pluralLogs(group.count)}
          extra={dayExtra ? dayExtra(group) : ""}
        />
        {group.logs.map((log) => (
          <TimeLogRow
            key={log.id}
            log={log}
            onOpen={onOpen}
            menuItems={menuItemsFor ? menuItemsFor(log) : []}
            {...rowProps}
            {...(rowPropsFor ? rowPropsFor(log) : {})}
          />
        ))}
      </section>
    ));

  if (groupByEmployee) {
    return groupByEmployee.map(([employeeName, employeeLogs]) => {
      const summary = summarizeLogs(employeeLogs);
      return (
        <section key={employeeName} className="tl-emp">
          <div className="tl-emp__head">
            <span className="tl-emp__name">{employeeName}</span>
            <span className="tl-emp__total">
              {summary.durationLabel} · {pluralLogs(summary.count)}
              {employeeExtra ? ` · ${employeeExtra(employeeName, employeeLogs)}` : ""}
            </span>
          </div>
          {renderDays(employeeLogs)}
        </section>
      );
    });
  }

  return renderDays(logs);
}
